import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import s from './styles.module.scss'

import { LoginModalValidateDigitCodeForm } from './form/LoginModalValidateDigitCodeForm'
import { LoginModalValidateDigitCodeProps } from '../login.types'
import { HelperText } from '../login-modal-subscribe/helper-text/HelperText'
import { Icon, IconSvg } from '../../../atoms'
import { Modal } from '../../../molecules'

export const LoginModalValidateDigitCode = ({
  isLoading,
  onValidateDigitCode,
  onRequestNewDigitCode,
  userEmail,
  modalType,
  helperText,
}: LoginModalValidateDigitCodeProps) => {
  const intl = useIntl()

  let errorMessage

  if (helperText?.type === 'error') {
    errorMessage = helperText.message
  }

  return (
    <Modal
      isOpen={true}
      title={
        <div className={s.titleWrapper}>
          <IconSvg.ArrowLeft
            onClick={modalType.options?.onGoBack}
            className={s.iconArrowLeft}
          />
          <Icon
            name='email-filled'
            color='black'
            size={16}
            className={s.icon}
          />
          <FormattedMessage
            id='ui.loginModalValidateDigitCode.emailSent'
            defaultMessage='E-mail envoyé'
          />
        </div>
      }
      className={s.loginModalValidateDigitCode}
      applyInnerStyle={false}
      navBar={
        <div className={s.headerMobile}>
          <IconSvg.ArrowLeft
            onClick={modalType.options?.onGoBack}
            className={s.iconArrowLeft}
          />
          <Icon
            name='email-filled'
            color='black'
            size={16}
            className={s.icon}
          />
          <FormattedMessage
            id='ui.loginModalValidateDigitCode.emailSent'
            defaultMessage='E-mail envoyé'
          />
        </div>
      }
    >
      {userEmail ? (
        <>
          <LoginModalValidateDigitCodeForm
            onRequestNewDigitCode={onRequestNewDigitCode}
            onValidateDigitCode={onValidateDigitCode}
            isLoading={isLoading}
            userEmail={userEmail}
            errorMessage={errorMessage}
          />
        </>
      ) : (
        <HelperText
          message={intl.formatMessage({
            id: 'ui.loginModalValidateDigitCode.error',
            defaultMessage:
              "Une erreur s'est produite. Veuillez réessayer plus tard.",
          })}
          type='error'
        />
      )}
    </Modal>
  )
}
